<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="!this.create" label="_ID" label-for="id-input">
          <b-form-input id="id-input" v-model="formValues.id" autocomplete="off" disabled />
        </b-form-group>

        <b-form-group label="Domain" label-for="domain-input">
          <b-form-input
            id="domain-input"
            type="text"
            v-model="formValues.domain"
            v-validate="{ required: true, regex: /^[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/ }"
            :state="validateState('domain')"
            aria-describedby="domain-live-feedback"
            data-vv-name="domain"
            data-vv-as="Domain"
            autocomplete="off"
            required
          />
          <b-form-invalid-feedback id="domain-live-feedback">{{ veeErrors.first('domain') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Operator" label-for="operator-input">
          <b-form-input
            id="operator-input"
            type="text"
            v-model="formValues.operator"
            v-validate="{ required: true }"
            :state="validateState('operator')"
            aria-describedby="operator-live-feedback"
            data-vv-name="operator"
            data-vv-as="Operator"
            autocomplete="off"
            required
          />
          <b-form-invalid-feedback id="operator-live-feedback">{{ veeErrors.first('operator') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Order" label-for="order-input">
          <b-form-input
            id="order-input"
            type="number"
            v-model="formValues.order"
            v-validate="this.create ? { numeric: true } : { required: true, numeric: true }"
            :state="validateState('order')"
            aria-describedby="order-live-feedback"
            data-vv-name="order"
            data-vv-as="Order"
            autocomplete="off"
            :required="!this.create"
            placeholder="(default)"
          />
          <b-form-invalid-feedback id="order-live-feedback">{{ veeErrors.first('order') }}</b-form-invalid-feedback>
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
    }
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        domain: null,
        operator: null,
        order: null,
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();
      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }
      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      for (let key of Object.keys(this.formValues)) {
        if (typeof this.formValues[key] === 'string') {
          this.formValues[key] = this.formValues[key].trim();
        }
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
          .$http({
            url: this.create ? '/api/v1/proxy-domains' : '/api/v1/proxy-domains/' + this.formValues.id,
            data: {
              domain: this.formValues.domain,
              operator: this.formValues.operator,
              order: this.formValues.order === null || this.formValues.order === ''
                ? null
                : Number.parseInt(this.formValues.order, 10),
            },
            method: this.create ? 'POST' : 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish');
            }, 500);

            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            let message;
            if (typeof err.response.data.message === 'string') {
              message = err.response.data.message;
            } else {
              message = JSON.stringify(err.response.data.message);
            }
            this.$toastr.e(message);
            throw err;
          });
      });
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>

